<template>
  <section v-if="list && list.length > 0" class="flex flex-col gap-2">
    <span class="text-sm font-bold">
      {{ title }}:
    </span>
    <div class="flex flex-col gap-1">
      <template v-for="item in list">
        <router-link @click="$emit('close')" :to="{path: item.link}" class="px-3 py-2 hover:bg-black/5 dark:hover:bg-white/5 rounded" :class="class">
          <slot :item="item"></slot>
        </router-link>  
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: "SearchList",
  props: {
    list: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      required: true
    },
    class: {
      type: [String, Array, Object],
      default: ''
    },
  }
};
</script>

<style lang="scss" scoped></style>